import React from "react";
import moment from "moment";
import ReactTable from "react-table";
import matchSorter from "match-sorter";
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelSheet;

class CierreCajaCentralizado extends React.Component {
    constructor(props) {
        super(props);
        
        const fechaActual = this.formatMomentForInput(moment());
        const fechaMinima = this.formatMomentForInput(moment().subtract(7, 'days'));
        
        this.state = {
            cajas: [],
            columns: [],
            isLoading: false,

            fechaInicio: fechaActual,
            fechaFin: fechaActual,
            fechaMinima: fechaMinima,
            fechaMaxima: fechaActual
        }


        this.formatAmount = this.formatAmount.bind(this);
    }

    formatAmount = (amount) => {
        let monto = parseFloat(amount);
        if (isNaN(monto)) {
            monto = 0;
        }

        const formattedMonto = monto.toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })

        return `S/ ${formattedMonto}`;
    }
    
    componentDidMount = async () => {
        this.setState({
            isLoading: true
        });

        this.fetchTurnos();
    }

    fetchTurnos = async () => {

        try {
            this.setState({ isLoading: true, error: null });
            const req = await fetch(`/api/cajas/cajas-sucursal?fechaInicio=${this.state.fechaInicio}&fechaFin=${this.state.fechaFin}`);
            
            if (!req.ok) {
                throw new Error(`Error ${req.status}: ${req.statusText}`);
            }
            
            const data = await req.json();
            this.setState({
                cajas: data,
                isLoading: false
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            this.setState({
                error: "Error al cargar los datos de cierre de caja",
                isLoading: false,
                cajas: []
            });
        }

    }

    formatMomentForInput = (momentDate) => {
        return momentDate.format("YYYY-MM-DD");
    }

   onChangeFecha = (e) => {
        const { name, value } = e.target;
        
        this.setState(prevState => {
            let newState = { [name]: value };
            
            if (name === 'fechaInicio') {
                if (value > prevState.fechaFin) {
                    newState.fechaFin = value;
                }
            } else if (name === 'fechaFin') {
                if (value < prevState.fechaInicio) {
                    newState.fechaInicio = value;
                }
            }
            
            return newState;
        }, () => {
            setTimeout(() => {
                this.fetchTurnos();
            }, 800);
        });
    }
    getMaxFechaFin = () => {
        return this.formatMomentForInput(moment());
    }

    getMinFechaInicio = () => {
        return this.formatMomentForInput(moment().subtract(7, 'days'));
    }

    getMaxFechaInicio = () => {
        return this.state.fechaFin;
    }

    getMinFechaFin = () => {
        return this.state.fechaInicio;
    }
    sanitizeValue(value, decimals) {
        if (value === null || value === undefined) {
            return "";
        }
        if (typeof value === "number") {
            return typeof decimals === "number" ? value.toFixed(decimals) : value;
        }
        if (typeof value === "string") {
            let num = Number(value);
            if (!isNaN(num) && typeof decimals === "number") {
                return num.toFixed(decimals);
            }
            return value.trim().replace(/[\x00-\x1F\x7F-\x9F]/g, "");
        }
        return String(value);
    }

    getDataCierreExportExcel(dataSet) {
        const dataToExport = Array.isArray(dataSet) ? dataSet:[];
        return [
            {
                columns:[
                    { title: "Caja", width: { wpx: 100 }}, 
                    { title: "Sucursal", width: { wpx: 100 }},
                    { title: "Usuario", width: { wpx: 100 }},
                    { title: "FechaInicio", width: { wpx: 150 }},
                    { title: "FechaCierre", width: { wpx: 150 }},
                    { title: "MontoApertura", width: { wpx: 150 }},
                    { title: "T. Entregar", width: { wpx: 150 }},
                    { title: "Efectivo Sis.", width: { wpx: 150 }},
                    { title: "Efectivo Usuario", width: { wpx: 150 }},
                    { title: "Yape Sis.", width: { wpx: 150 }},
                    { title: "Yape Usuario", width: { wpx: 150 }},
                    { title: "Pos Sis.", width: { wpx: 150 }},
                    { title: "Pos Usuario", width: { wpx: 150 }},
                    { title: "Plin Sis.", width: { wpx: 150 }},
                    { title: "Plin Usuario", width: { wpx: 150 }},
                    { title: "O. Tarjeta Sis.", width: { wpx: 150 }},
                    { title: "O. Tarjeta Usuario", width: { wpx: 150 }},
                ],
                data: dataToExport.map(row => {
                    return [
                        { value: this.sanitizeValue(row.NombreCaja), style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.NombreSucursal) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.NombreUsuario) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.FechaInicio) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.FechaFin || "En Curso") , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoInicial) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalEfectivoSistema) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalEfectivoSistema) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalEfectivoFisico) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalYapeSistema) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalYape) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalTarjetaVisaSistema) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalTarjetaVisaFisico) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalPlinSistema) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalPlin) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalOtraTarjetaSistema) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                        { value: this.sanitizeValue(row.MontoFinalOtraTarjetaFisico) , style: { font: { sz: "12", bold: false }, alignment: { horizontal: "left" } } },
                    ]
                })
            }
        ]
    }

    render(){
        const {cajas, isLoading, error, fecha} = this.state;

        let dataExcel = null;
        if (cajas && cajas.length > 0) {
            dataExcel = this.getDataCierreExportExcel(cajas);
        }

        return ( 
            <section className="ventas-fpay-section-vh pt-5">
                <div className="">
                    {/* <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2">
                        <span className="align-self-center letra-fecha-fpay">
                            Fecha:
                        </span>

                        <input  type="date"
                                className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                                name="fecha"
                                onChange={this.onChangeFecha}
                                value={this.state.fecha}/>

                    </div> */}
                    <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2">
                        <span className="align-self-center letra-fecha-fpay">
                            Desde:
                        </span>
                        <div className="col-sm">
                            <input disabled={this.state.isLoading} type="date" onChange={this.onChangeFecha}
                                name="fechaInicio"
                                className="input__linea mr-1 mt-3 mb-3 linea-fecha-fpay" value={this.state.fechaInicio}
                                min={this.getMinFechaInicio()}
                                max={this.getMaxFechaInicio()}/>
                                
                        </div>
                        <span className="align-self-center letra-fecha-fpay">
                            Hasta:
                        </span>
                        <div className="col-sm">
                            <input disabled={this.state.isLoading} type="date" onChange={this.onChangeFecha}
                                name="fechaFin" className="input__linea mr-1 mt-3 mb-3 linea-fecha-fpay"
                                value={this.state.fechaFin}
                                min={this.getMinFechaFin()}
                                max={this.getMaxFechaFin()}/>
                        </div>
                    </div>
                    <div className="container">
                    <div align ="right" className="seccion-btn-verde-mfp pt-3 mb-2">
                        <button style={{border:'none', background:'none'}}>

                            <ExcelFile
                                element={
                                     <button 
                                    className="boton__verdeOscuro"
                                    disabled={!cajas || cajas.length === 0}
                                    >
                                        <i className="fas fa-file-excel"></i>
                                    </button>
                                }
                                filename={`ReporteCierreCentral_${fecha}`}
                            >
                                <ExcelSheet
                                    dataSet={dataExcel}
                                    name="Cajas"
                                />
                            </ExcelFile>
                        </button>
                    </div>
                    <ReactTable
                        id="table-productos-to-xls"
                        data={this.state.cajas}
                        pages={-1}
                        loading={this.state.isLoading}
                        defaultFilterMethod={(filter, row) =>
                            String(row[filter.id]) === filter.value
                        }
                        manual={true}
                        filterable={true}
                        sortable={true}
                        columns={[
                            {
                                columns: [
                                    {
                                        Header: "Caja",
                                        id: "Caja",
                                        width: 120,
                                        accessor: d => d.NombreCaja,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Caja"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Sucursal",
                                        id: "Sucursal",
                                        width: 120,
                                        accessor: d => d.NombreSucursal,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Sucursal"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Usuario",
                                        id: "Usuario",
                                        width: 130,
                                        accessor: d => d.NombreUsuario,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Usuario"]}),
                                        filterAll: true
                                    },
                                    {
                                        id: 'FechaInicio',
                                        Header: 'Fecha Inicio',
                                        width: 200,
                                        accessor: d => d.FechaInicio
                                    },
                                    {
                                        id: 'FechaCierre',
                                        Header: 'Fecha Cierre',
                                        width: 200,
                                        accessor: d => d.FechaFin || "En curso"
                                    },
                                    {
                                        id: "MontoInicial",
                                        Header: "Monto apertura",
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoInicial)
                                    },
                                    {
                                        id: 'total',
                                        Header: 'Total a entregar',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalEfectivoSistema)
                                    },
                                    {
                                        Header: "Efectivo Sis.",
                                        id: "EfectivoS",
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalEfectivoSistema),
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["EfectivoS"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Efectivo Usuario",
                                        id: "Efectivo",
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalEfectivoFisico),
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Efectivo"]}),
                                        filterAll: true
                                    },
                                    {
                                        id: 'YAPES',
                                        Header: 'YAPE Sis.',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalYapeSistema)
                                    },
                                    {
                                        id: 'YAPE',
                                        Header: 'YAPE Usuario',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalYape)
                                    },
                                    {
                                        id: 'POSS',
                                        Header: 'POS Sis.',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalTarjetaVisaSistema)
                                    },
                                    {
                                        id: 'POS',
                                        Header: 'POS Usuario',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalTarjetaVisaFisico)
                                    },
                                    {
                                        id: 'Plin',
                                        Header: 'Plin Sis.',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalPlinSistema)
                                    },
                                    {
                                        id: 'PlinS',
                                        Header: 'Plin Usuario',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalPlin)
                                    },
                                    {
                                        id: 'OtraTarjetaS',
                                        Header: 'Otra Tarjeta Sis.',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalOtraTarjetaSistema)
                                    },
                                    {
                                        id: 'OtraTarjeta',
                                        Header: 'Otra Tarjeta Usuario',
                                        width: 150,
                                        accessor: d => this.formatAmount(d.MontoFinalOtraTarjetaFisico)
                                    },
                                ]
                                }
                            ]}
                            defaultPageSize={10}
                            className="-striped -highlight"
                            previousText="Anterior"
                            nextText="Siguiente"
                            noDataText="No se encontraron registros"
                            loadingText="Cargando..."
                            ofText="de"
                            rowsText="filas"
                            pageText="Página"
                            pageSizeOptions={[10, 20, 25, 50, 100]}
                        />

                    </div>
                </div>
            </section>
        );
    }
}

export default CierreCajaCentralizado;